import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';

const Container = styled('div', {
  position: 'relative',
  minHeight: 30,
});

const Overlay = styled('div', {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  background: 'rgba(255, 255, 255, 0.85)',
  zIndex: 100,
});

const Content = styled('div', {
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center',
});

const Text = styled('div', {
  textTransform: 'uppercase',
  fontWeight: 'bold',
  color: '$accent1',
});

export const Loading = ({ children, isLoading, message, ...props }) => {
  return (
    <Container {...props} data-loading={isLoading}>
      {isLoading && (
        <Overlay>
          <Content>
            <LoadingSpinner isLoading={isLoading} size="$lg" />
            <Text>{message}</Text>
          </Content>
        </Overlay>
      )}
      {children}
    </Container>
  );
};

Loading.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

Loading.defaultProps = {
  children: null,
  isLoading: false,
  message: 'Loading...',
};
